import { GraduationCap, Award, Heart } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-20 sm:py-28 lg:py-32 bg-slate-50/70"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-12 gap-8 lg:gap-12 items-center">
          {/* Image block */}
          <div className="col-span-12 lg:col-span-5 order-2 lg:order-1">
            <div className="relative">
              <div className="rounded-[32px] overflow-hidden ring-1 ring-slate-900/5 shadow-xl shadow-blue-900/10">
                <img
                  src="https://static.wixstatic.com/media/6616d1_8c6378cb70454153ac5804f14e8f7f39~mv2.jpg/v1/fill/w_900,h_900,al_c,q_85,enc_auto/dennis-lee-working-with-client.jpg"
                  alt="Dennis Lee, RAPID NeuroFascial Reset Specialist, working with a client at KneadRelief"
                  className="w-full h-[440px] object-cover object-center"
                  loading="lazy"
                />
              </div>

              <div className="absolute -bottom-8 right-4 sm:right-8 bg-white rounded-2xl px-6 py-5 shadow-xl shadow-blue-900/10 border border-slate-100 max-w-[280px]">
                <div className="flex items-start gap-3">
                  <Award size={22} className="text-blue-800 mt-0.5 shrink-0" strokeWidth={1.6} />
                  <div>
                    <div className="font-display font-bold text-slate-900 text-base leading-tight">
                      MH Vicars Graduate
                    </div>
                    <div className="text-xs text-slate-500 mt-1">
                      Trained in advanced manual therapy & RAPID NFR
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Text block */}
          <div className="col-span-12 lg:col-span-7 order-1 lg:order-2">
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-blue-800 mb-4">
              Meet Dennis Lee
            </div>
            <h2
              data-testid="about-heading"
              className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 leading-[1.1]"
            >
              I help people in pain feel better — <span className="text-blue-800">again.</span>
            </h2>

            <div className="mt-6 space-y-4 text-slate-600 text-lg leading-relaxed max-w-2xl">
              <p>
                I made the leap from IT to therapy because I believe in solutions —
                in finding the <em className="text-slate-900 not-italic font-semibold">'why'</em> behind the <em className="text-slate-900 not-italic font-semibold">'ouch'</em>.
              </p>
              <p>
                It's not just about muscle, joint and nerve pain. It's about the moments
                you're missing because of that pain. With advanced massage and{" "}
                <a href="#rapid" className="text-blue-800 font-semibold underline-offset-4 hover:underline">
                  RAPID NeuroFascial Reset
                </a>
                , I don't just soothe — I search for the source and address it.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {[
                { icon: GraduationCap, title: "Trained", desc: "MH Vicars School of Massage Therapy" },
                { icon: Award, title: "Certified", desc: "RAPID NeuroFascial Reset Specialist" },
                { icon: Heart, title: "Personalised", desc: "Care designed around you, not a label" },
              ].map((b) => (
                <div
                  key={b.title}
                  className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all"
                >
                  <b.icon size={22} strokeWidth={1.6} className="text-blue-800 mb-3" />
                  <div className="font-display font-bold text-slate-900">{b.title}</div>
                  <div className="text-sm text-slate-500 mt-1 leading-snug">{b.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
